import React, { useEffect, useState } from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';
import './index.scss';

const ns = 'page-navigation';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
    isMobile: !(width >= 1024),
  };
}

/**
 * Page with navigation Container
 */
export default ({
  children,
  updateAuth,
  sidebar,
  type,
  postLogoutAction,
  showStores = true,
  showAllOption = true,
}: any) => {
  const [showMenu, setShowMenu] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className={ns}>
      <Header
        updateAuth={updateAuth}
        type={type}
        setShowMenu={setShowMenu}
        postLogoutAction={postLogoutAction}
        windowDimensions={windowDimensions}
        showStores={showStores}
        showAllOption={showAllOption}
      />
      <Sidebar
        list={sidebar}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        windowDimensions={windowDimensions}
        type={type}
      />
      <main className={`${ns}__main`}>{children}</main>
    </div>
  );
};
